export default "__VITE_ASSET__CfTP2vwM__"